import { Chip, Stack } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function ActionDisplay({ action }) {
    const actionColor = getActionColor(action.type)
    const actionLabel = getActionLabel(action)

    return (
        <Stack direction="row" alignItems="center" spacing={0.5} sx={{ pt: 0.5 }}>
            <Iconify icon="mdi:arrow-right-bold" sx={{ fontSize: 14, color: actionColor }} />
            <Chip label={actionLabel} size="small" sx={{ height: 22, bgcolor: actionColor, color: "common.white" }} />
        </Stack>
    )

    function getActionColor(type) {
        if (type === "exclude") return "error.main"
        if (type === "modifier") return "warning.main"
        return "success.main"
    }

    function getActionLabel(a) {
        if (a.type === "modifier" && a.costKind === "fixed" && a.fixedAmount != null) {
            const sign = a.fixedAmount >= 0 ? "+" : ""
            return `Modifier: ${sign}${a.fixedAmount} fixed`
        }
        if (a.type === "modifier" && a.multiplier != null) return `Modifier: x${a.multiplier}`
        return a.type?.charAt(0).toUpperCase() + a.type?.slice(1)
    }
}
